module.exports = __webpack_public_path__ + "static/media/check.ca9b301d.png";